<template>
	<div ref="menuRef" class="dismiss-menu">
		<button class="dismiss-toggle" @click.stop="open = !open">
			<span class="ht-icon">expand_more</span>
		</button>
		<div v-if="open" class="dismiss-dropdown">
			<button class="dismiss-option" @click="dismissWith()">Negeren</button>
			<button class="dismiss-option" @click="dismissWith('verkeerde klant')">
				Verkeerde klant
			</button>
			<button class="dismiss-option" @click="dismissWith('verouderd document')">
				Verouderd document
			</button>
			<button class="dismiss-option" @click="dismissWith('handmatig verwerkt')">
				Handmatig verwerkt
			</button>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, useTemplateRef } from "vue";

const emit = defineEmits<{
	dismiss: [reason?: string];
}>();

const open = ref(false);
const menuRef = useTemplateRef("menuRef");

function handleClickOutside(e: MouseEvent) {
	if (
		open.value &&
		menuRef.value &&
		!menuRef.value.contains(e.target as Node)
	) {
		open.value = false;
	}
}

onMounted(() => document.addEventListener("click", handleClickOutside));
onUnmounted(() => document.removeEventListener("click", handleClickOutside));

function dismissWith(reason?: string) {
	open.value = false;
	emit("dismiss", reason);
}
</script>

<style scoped>
.dismiss-menu {
	position: relative;
}

.dismiss-toggle {
	padding: 0.25rem;
	color: var(--text-muted, #6b7280);
	background: none;
	border: none;
	cursor: pointer;
	border-radius: 0.25rem;
}

.dismiss-toggle:hover {
	background: var(--background-primary-hover, #f3f4f6);
}

.dismiss-dropdown {
	position: absolute;
	right: 0;
	top: 100%;
	background: white;
	border: 1px solid var(--border, #e5e7eb);
	border-radius: 0.375rem;
	box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
	z-index: 10;
	min-width: 180px;
}

.dismiss-option {
	display: block;
	width: 100%;
	text-align: left;
	padding: 0.5rem 0.75rem;
	font-size: 0.8rem;
	color: var(--text-primary, #111827);
	background: none;
	border: none;
	cursor: pointer;
}

.dismiss-option:hover {
	background: var(--background-primary-hover, #f3f4f6);
}
</style>
